import mixins from 'vue-typed-mixins';
import { PropType } from 'vue';
import _ from 'lodash';

import C保存Button from '@/components/保存Button/保存Button.vue';
import KeystrokeInputableText from '@/components/keystrokeInputableText/KeystrokeInputableText.vue';

import { KeystrokeInputableTextId } from '@/components/keystrokeInputableText/KeystrokeInputableText';

import AlertMixin from '@/mixins/AlertMixin';
import { InputableTextMixin } from '@/components/inputableText/InputableText';
import KeystrokeInputableTextMixin from '@/entries/user/mixins/KeystrokeInputableTextMixin';
import MoneyUnitLabelMixin from '@/entries/user/mixins/MoneyUnitLabelMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import 資金繰りService, { ValueCell, 資金繰りValueData, 資金繰り予定 } from '@/classes/service/計画/資金繰りService';

export default mixins(
  AlertMixin,
  InputableTextMixin,
  KeystrokeInputableTextMixin,
  MoneyUnitLabelMixin,
  RoutesMixin,
  計画書Mixin
).extend({
  name: 'C資金繰り表',

  components: {
    C保存Button,
    KeystrokeInputableText,
  },

  props: {
    service: {
      type: Object as PropType<資金繰りService>,
      required: true,
    },
    資金繰り予定: {
      type: Object as PropType<資金繰り予定>,
      default: null,
    },
  },

  computed: {
    map(): (KeystrokeInputableTextId | null)[][] {
      if (this.資金繰り予定 === null) return [];

      const canInput = (cell: ValueCell): boolean =>
        cell.vHtml === undefined && (cell.data !== undefined || cell.is月初資金残高 === true);

      return this.資金繰り予定.valueTable.body.map((item, i) => [
        ...Array(16 - item.cells.length).fill(null),
        ...item.cells.map((cell, j) => (canInput(cell) ? { i, j } : null)),
      ]);
    },
  },

  watch: {
    資金繰り予定(): void {
      this.setFirstKeystrokeId(this.map);
    },
  },

  methods: {
    async save(): Promise<void> {
      const response = await this.service.update(this.資金繰り予定.データpk!, this.service.cデータ資金繰り!);
      if (this.isValidationErrorResponse(response)) return;

      window.alert('保存しました');

      this.service.orgCデータ資金繰り = _.cloneDeep(this.service.cデータ資金繰り);
      this.資金繰り予定.isEditing = false;
    },
    recalculate(): void {
      const value = this.資金繰り予定.value;
      this.service.deleteAllInput(value);
      this.service.calculateSums(value);
      this.資金繰り予定.valueTable = this.service.createValueTable(value);

      this.資金繰り予定.isEditing = true;
    },
    changeValue(data: 資金繰りValueData, input: number): void {
      if (data.input === undefined) {
        data.input = { ...data.inputKey!, value: 0 };
        const index = this.資金繰り予定.value.yearMonths.indexOf(data.inputKey!.ym);
        this.service.cデータ資金繰り!.monthlyValues[index].values.push(data.input);
      }

      data.input.value = input;
      this.service.checkInputValue(this.資金繰り予定.value.yearMonths, data);

      const value = this.資金繰り予定.value;
      this.service.calculateSums(value);
      this.資金繰り予定.valueTable = this.service.createValueTable(value);

      this.資金繰り予定.isEditing = true;
    },
    change月初資金残高(input: number): void {
      this.資金繰り予定.value.月初資金残高 = input;
      this.service.cデータ資金繰り!.monthlyValues[0].月初資金残高 = input;
    },
  },
});
